(function () {
  'use strict';

  if (window.console && console.info) console.info('[mt-samenstellen-pagina] script geladen v4');

  function init() {
    var root = document.getElementById('mt-sp');
    if (!root || root.dataset.mtInit === '1') return;
    root.dataset.mtInit = '1';

    var standaardLevertijd = root.dataset.standaardLevertijd || 'Gratis bezorgd binnen 7 werkdagen';

    var elKeuze = document.getElementById('mt-sp-keuze');
    var elTotaal = document.getElementById('mt-sp-totaal');
    var elLever = document.getElementById('mt-sp-levertijd');
    var elLeverTekst = document.getElementById('mt-sp-levertijd-tekst');
    var elBtn = document.getElementById('mt-sp-btn');
    var elFout = document.getElementById('mt-sp-fout');
    var elPreviewFoto = document.getElementById('mt-sp-previewfoto');
    var elPreviewTitel = document.getElementById('mt-sp-previewtitel');
    var elPreview = document.getElementById('mt-sp-preview');
    var elPreviewAnker = document.getElementById('mt-sp-previewanker');
    var elBtnTekst = document.getElementById('mt-sp-btntekst');
    var mobiel = window.matchMedia('(max-width: 989px)');

    var modal = document.getElementById('mt-sp-modal');
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var actiefPaneel = null;
    var fotos = {};
    var gekozen = { blad: null, poot: null };

    function euro(centen) {
      return '\u20AC\u00A0' + (centen / 100).toFixed(2).replace('.', ',');
    }

    function zetPreview(url, titel) {
      if (url) {
        elPreviewFoto.src = url;
        elPreviewFoto.alt = titel || '';
      }
      if (titel) elPreviewTitel.textContent = titel;
    }

    function plaatsPreview() {
      if (!elPreview) return;
      if (mobiel.matches && actiefPaneel) {
        var pootGrid = actiefPaneel.querySelector('.mt-sp__grid--poot');
        if (pootGrid && pootGrid.nextElementSibling !== elPreview) {
          pootGrid.insertAdjacentElement('afterend', elPreview);
        }
      } else if (!mobiel.matches && elPreviewAnker &&
                 elPreviewAnker.nextElementSibling !== elPreview) {
        elPreviewAnker.insertAdjacentElement('afterend', elPreview);
      }
    }

    if (mobiel.addEventListener) {
      mobiel.addEventListener('change', plaatsPreview);
    }

    /* ---------- Selectiefuncties ---------- */
    function kiesVorm(kaart, metScroll) {
      var vorm = kaart.dataset.vorm;
      root.querySelectorAll('.mt-sp__vormkaart').forEach(function (k) { k.classList.remove('is-active'); });
      kaart.classList.add('is-active');

      root.querySelectorAll('.mt-sp__maten').forEach(function (m) { m.hidden = m.dataset.vorm !== vorm; });

      root.querySelectorAll('.mt-sp__pill').forEach(function (p) { p.classList.remove('is-active'); });

      var eerstePill = root.querySelector('.mt-sp__maten[data-vorm="' + vorm + '"] .mt-sp__pill');
      if (eerstePill) kiesMaat(eerstePill, false);

      if (metScroll) {
        document.getElementById('mt-sp-stap2').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function kiesMaat(pill, metScroll) {
      root.querySelectorAll('.mt-sp__pill').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');

      var id = pill.dataset.paneel;
      actiefPaneel = null;
      root.querySelectorAll('.mt-sp__paneel').forEach(function (p) {
        p.hidden = p.dataset.paneel !== id;
        if (p.dataset.paneel === id) actiefPaneel = p;
      });
      if (!actiefPaneel) return;

      fotos = {};
      var mapEl = actiefPaneel.querySelector('.mt-sp__fotomap');
      if (mapEl) { try { fotos = JSON.parse(mapEl.textContent); } catch (err) {} }

      actiefPaneel.querySelectorAll('.mt-sp__card').forEach(function (c) { c.classList.remove('is-active'); });
      gekozen = { blad: null, poot: null };

      zetPreview(actiefPaneel.dataset.foto, actiefPaneel.dataset.titel + ' \u00B7 kies blad en poot');
      plaatsPreview();
      update();

      if (metScroll) {
        document.getElementById('mt-sp-main').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    /* ---------- Klikafhandeling ---------- */
    root.addEventListener('click', function (e) {
      var vormKaart = e.target.closest('.mt-sp__vormkaart');
      if (vormKaart) { kiesVorm(vormKaart, true); return; }

      var pill = e.target.closest('.mt-sp__pill');
      if (pill) { kiesMaat(pill, false); return; }

      var kaart = e.target.closest('.mt-sp__card');
      if (kaart && actiefPaneel && actiefPaneel.contains(kaart)) {
        var type = kaart.dataset.type;
        actiefPaneel.querySelectorAll('.mt-sp__card[data-type="' + type + '"]').forEach(function (k) {
          k.classList.remove('is-active');
        });
        kaart.classList.add('is-active');
        gekozen[type] = kaart;
        elFout.hidden = true;
        update();
      }
    });

    /* ---------- Levertijd ---------- */
    function toonLevertijd(b, p) {
      var uitVoorraad = [];
      if (b && b.dataset.voorraad === '0') uitVoorraad.push(b);
      if (p && p.dataset.voorraad === '0') uitVoorraad.push(p);

      if (uitVoorraad.length === 0) {
        var traagstOpVoorraad = [b, p].filter(Boolean).sort(function (x, y) { return (parseInt(y.dataset.rang, 10) || 3) - (parseInt(x.dataset.rang, 10) || 3); })[0];
        /* traagste bezorgmethode bepaalt (data-rang 1 = PostNL, 2 = Max/XXL, 3 = Starfurn-75) */
        elLeverTekst.textContent = 'Op voorraad \u00B7 ' + ((traagstOpVoorraad && traagstOpVoorraad.dataset.levertijd) || standaardLevertijd);
        elLever.classList.remove('is-later');
        return;
      }
      var traagste = uitVoorraad[0];
      for (var i = 1; i < uitVoorraad.length; i++) {
        if ((uitVoorraad[i].dataset.levertijd || '').length > (traagste.dataset.levertijd || '').length) {
          traagste = uitVoorraad[i];
        }
      }
      var wat = uitVoorraad.length === 2
        ? 'Tafelblad en tafelpoot zijn niet op voorraad'
        : (traagste.dataset.type === 'blad' ? 'Dit tafelblad is niet op voorraad' : 'Deze tafelpoot is niet op voorraad');
      elLeverTekst.textContent = wat + ' \u00B7 ' + (traagste.dataset.levertijd || standaardLevertijd) +
        ' \u00B7 wordt compleet bezorgd';
      elLever.classList.add('is-later');
    }

    /* ---------- Samenvatting ---------- */
    function update() {
      if (!actiefPaneel) return;
      var b = gekozen.blad;
      var p = gekozen.poot;
      var titel = actiefPaneel.dataset.titel;

      toonLevertijd(b, p);

      if (!b || !p) {
        elKeuze.textContent = !b && !p
          ? 'Kies een tafelblad en een tafelpoot'
          : (!b ? 'Kies nog een tafelblad' : 'Kies nog een tafelpoot');
        elTotaal.textContent = '';
        elBtn.disabled = true;

        if (b) {
          var refPoot = p || actiefPaneel.querySelector('.mt-sp__card[data-type="poot"]');
          if (refPoot) {
            var voorbeeld = fotos[b.dataset.kleur + '|' + refPoot.dataset.fotokey];
            if (voorbeeld) {
              zetPreview(voorbeeld, titel + ' \u00B7 ' + b.dataset.naam + ' blad \u00B7 kies nog een poot');
            }
          }
        }
        return;
      }

      var totaal = parseInt(b.dataset.prijs, 10) + parseInt(p.dataset.prijs, 10);
      elTotaal.textContent = euro(totaal);
      elKeuze.textContent = titel + ' \u00B7 ' + b.dataset.naam + ' blad \u00B7 ' + p.dataset.naam;

      var volledig = titel + ' \u00B7 ' + b.dataset.naam + ' blad \u00B7 ' + p.dataset.naam;
      var combi = fotos[b.dataset.kleur + '|' + p.dataset.fotokey];
      zetPreview(combi || null, volledig);

      elBtn.disabled = false;
    }

    /* ---------- Winkelwagen ---------- */
    elBtn.addEventListener('click', function () {
      var b = gekozen.blad;
      var p = gekozen.poot;
      if (!b || !p || !actiefPaneel) return;

      var setId = 'set-' + Date.now().toString(36);
      var omschrijving = actiefPaneel.dataset.titel + ' \u2013 ' + b.dataset.naam + ' blad + ' + p.dataset.naam;

      elBtn.disabled = true;
      if (elBtnTekst) elBtnTekst.textContent = 'Bezig met toevoegen...';
      elFout.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(b.dataset.id, 10), quantity: 1,
              properties: { '_set': setId, '_onderdeel': 'tafelblad', 'Samengestelde tafel': omschrijving } },
            { id: parseInt(p.dataset.id, 10), quantity: 1,
              properties: { '_set': setId, '_onderdeel': 'tafelpoot', 'Samengestelde tafel': omschrijving } }
          ]
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          if (elBtnTekst) elBtnTekst.textContent = 'Toegevoegd aan winkelwagen';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(function () { window.location.href = '/cart'; }, 500);
        })
        .catch(function () {
          elBtn.disabled = false;
          if (elBtnTekst) elBtnTekst.textContent = 'Voeg toe aan winkelwagen';
          elFout.hidden = false;
          elFout.textContent = 'Het toevoegen is niet gelukt. Probeer het opnieuw of neem contact met ons op.';
        });
    });

    /* ---------- Info-modal ---------- */
    function openModal(knop) {
      if (!modal) return;
      document.getElementById('mt-sp-modal-titel').textContent = knop.dataset.modalTitel || '';
      document.getElementById('mt-sp-modal-prijs').textContent = knop.dataset.modalPrijs || '';
      document.getElementById('mt-sp-modal-oms').textContent = knop.dataset.modalOms || '';
      document.getElementById('mt-sp-modal-lever').textContent = knop.dataset.modalLevertijd || '';
      var img = document.getElementById('mt-sp-modal-foto');
      if (knop.dataset.modalFoto) {
        img.src = knop.dataset.modalFoto;
        img.alt = knop.dataset.modalTitel || '';
        img.parentElement.hidden = false;
      } else {
        img.parentElement.hidden = true;
      }
      var link = document.getElementById('mt-sp-modal-link');
      if (knop.dataset.modalUrl) {
        link.href = knop.dataset.modalUrl;
        link.textContent = knop.dataset.modalLinktekst || 'Bekijk meer informatie';
        link.style.display = '';
      } else {
        link.style.display = 'none';
      }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function sluitModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.classList.remove('mt-sp__modal--zoom', 'mt-sp__modal--groot');
      document.body.style.overflow = '';
    }

    function openFotoModal() {
      if (!modal) return;
      document.getElementById('mt-sp-modal-titel').textContent = elPreviewTitel.textContent || '';
      document.getElementById('mt-sp-modal-prijs').textContent = '';
      document.getElementById('mt-sp-modal-oms').textContent = '';
      document.getElementById('mt-sp-modal-lever').textContent = '';
      document.getElementById('mt-sp-modal-link').style.display = 'none';
      var img = document.getElementById('mt-sp-modal-foto');
      img.src = elPreviewFoto.src;
      img.alt = elPreviewFoto.alt;
      img.parentElement.hidden = false;
      modal.classList.remove('mt-sp__modal--zoom');
      modal.classList.add('mt-sp__modal--groot');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    var elPreviewKnop = document.getElementById('mt-sp-previewknop');
    if (elPreviewKnop) {
      elPreviewKnop.addEventListener('click', openFotoModal);
    }

    document.addEventListener('click', function (e) {
      var infoKnop = e.target.closest('.mt-sp__info');
      if (infoKnop) {
        e.preventDefault();
        modal.classList.remove('mt-sp__modal--groot', 'mt-sp__modal--zoom');
        openModal(infoKnop);
        return;
      }
      if (e.target.closest('#mt-sp-modal [data-modal-sluit]')) { sluitModal(); return; }
      if (e.target.closest('#mt-sp-modal-foto')) {
        modal.classList.toggle('mt-sp__modal--zoom');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) sluitModal();
    });

    /* ---------- Startstand: eerste vorm en maat voorgeselecteerd ---------- */
    var eersteVorm = root.querySelector('.mt-sp__vormkaart');
    if (eersteVorm) kiesVorm(eersteVorm, false);
    plaatsPreview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();